import * as React from 'react'

import { Theme } from '@mui/material/styles'

import Typography from '@mui/material/Typography'

import { RowErrors } from './RowErrors'
import type { ValidationCallback } from './typings'
import { useFormFieldActions, useValidateRows } from './hooks'
import { CustomActionBar } from '@sales-center/components'
import { ENTITY_TYPES } from '@sales-center/common'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { useCallback, useState } from 'react'
import { useLocalizationDateFormat } from '@user/features/Localization/useLocalizationDateFormat'

const styles = {
  root: {
    fontFamily: 'Source Sans Pro SemiBold',
    marginTop: (theme: Theme) => theme.spacing(0.5),
  },
}

type Props = {
  validateRows: ValidationCallback
  setUpdateExpected?: React.Dispatch<React.SetStateAction<boolean>>
}

export const FormFields: React.FC<Props> = (props) => {
  const { validateRows, setUpdateExpected } = props

  const [open, setOpen] = useState(false)
  const onOpen = useCallback(() => setOpen(true), [])
  const onClose = useCallback(() => setOpen(false), [])

  const { expectedClosingDate, onChangeExpectedClosingDate } =
    useFormFieldActions()

  const { getFormat } = useLocalizationDateFormat()

  const validationResults = useValidateRows(validateRows)
  const onCancelDialog = useCallback(() => {
    if (setUpdateExpected) setUpdateExpected(false)
    onChangeExpectedClosingDate(new Date())
    onClose()
  }, [onChangeExpectedClosingDate, onClose, setUpdateExpected])

  return (
    <>
      <Typography sx={{ ...styles.root }}>Set Expected Closing Date</Typography>
      <DatePicker
        label="Expected Closing Date"
        value={expectedClosingDate}
        open={open}
        onChange={onChangeExpectedClosingDate}
        closeOnSelect={false}
        onClose={onClose}
        onOpen={onOpen}
        format={getFormat()}
        slots={{
          actionBar: CustomActionBar,
        }}
        disablePast={false}
        slotProps={{
          actionBar: {
            /*eslint-disable */
            //@ts-ignore
            isnextactiondate: 'expectedclosing',
            disabled: !expectedClosingDate,
            setupdateotherdate: setUpdateExpected,
            entitytype: ENTITY_TYPES.Opportunity,
            actions: ['cancel', 'accept'],
            onCancel: onCancelDialog,
          },
          textField: {
            size: 'small',
            margin: 'normal',
            required: true,
            fullWidth: true,
          },
          popper: {
            placement: 'auto',
          },
        }}
      />
      <RowErrors {...validationResults} />
    </>
  )
}
FormFields.displayName = 'FormFields'
